export default {
  promo: () => import('./promo.json'),
  promoDetails: () => import('./promo-details.json'),
};
